import BankCard from '#features/BankCard';
import { ChannelSupplierBankDto } from '#services/api';
import { Button, Space } from '@bedrock/components';
import { ChevronRight } from '@bedrock/icons-react';
import React, { useImperativeHandle, forwardRef } from 'react';

interface Props {
  value?: ChannelSupplierBankDto,
  // 展示缺失收款账户信息tip
  showDeficiencyTip?: boolean;
}

const PaymentAccount = forwardRef(({
  value,
  showDeficiencyTip = true,
}: Props, ref) => {
  const handleClick = () => {
    window.open('/#/outCompanyManagement/outCompanyInfo');
  }

  useImperativeHandle(ref, () => ({
    getValue: () => value
  }))

  if (!value?.bank_account) {
    return <Space>
      {showDeficiencyTip &&  <span style={{ color: 'red' }}>缺失收款账户信息</span>}
      <Button type='link' suffixIcon={<ChevronRight />} onClick={handleClick}>前往补充</Button>
    </Space>
  }

  return (
    <div>
      <BankCard type='card' value={value} />
      <Button type='link' suffixIcon={<ChevronRight />} onClick={handleClick} className='m-t-4'>前往修改</Button>
    </div>
  )
})

export default PaymentAccount
